const base = () => new URL(process.env.BASE_URL || '/', window.location.origin)
export function pushSupported() { return window.isSecureContext && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window }
export async function pushRegistration() { return 'serviceWorker' in navigator ? navigator.serviceWorker.getRegistration(base().href) : null }
export async function registerPushWorker() {
  const registration = await navigator.serviceWorker.register(new URL('portal-push-sw.js', base()).href, { scope: base().pathname })
  if (registration.active) return registration
  await Promise.race([navigator.serviceWorker.ready, new Promise((_, reject) => setTimeout(() => reject(new Error('Не удалось подготовить уведомления. Повторите попытку.')), 15000))])
  return registration
}
export function pushOwner(registration, clientId) {
  if (!registration?.active) return Promise.resolve()
  return new Promise((resolve, reject) => {
    const channel = new MessageChannel()
    const timer = setTimeout(() => { channel.port1.close(); reject(new Error('Не удалось сохранить настройки устройства.')) }, 5000)
    channel.port1.onmessage = event => { clearTimeout(timer); channel.port1.close(); if (event.data?.ok) resolve(); else reject(new Error('Не удалось сохранить настройки устройства.')) }
    registration.active.postMessage({ type: 'portal-push-owner', clientId }, [channel.port2])
  })
}
export async function pushEndpoint() { const registration = await pushRegistration(); return (await registration?.pushManager?.getSubscription())?.endpoint || '' }
export async function clearPushDevice() {
  const registration = await pushRegistration()
  if (!registration) return
  await pushOwner(registration, 0)
  await (await registration.pushManager.getSubscription())?.unsubscribe()
}
export function decodePushKey(value) { return Uint8Array.from(atob(value.replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0)) }
